export default __webpack_public_path__ + "static/media/04n.d90800fe.png";